export default __webpack_public_path__ + "static/media/Red0002.614bd422.png";